export const AUTH = 'AUTH'
export const NOTIFY = 'NOTIFY'